@let isArabic = isArabic$ | async;

<section class="marketplace-hero" aria-labelledby="hero-title">
  <svg class="hero-definitions" width="0" height="0" aria-hidden="true" focusable="false">
    <defs>
      <clipPath id="hero-property-web" clipPathUnits="objectBoundingBox">
        <path d="M.64,0 C.60,.18 .56,.38 .51,.52 S.50,.74 .56,1 H1 V0 Z" />
      </clipPath>
    </defs>
  </svg>
  <div class="hero-visual" aria-hidden="true">
    <img
      class="hero-photo hero-photo-cars"
      src="images/car-background2.jpg"
      alt=""
      width="1344"
      height="768"
      fetchpriority="high"
      decoding="async"
    />
    <div class="hero-property-image">
      <img
        class="hero-photo hero-photo-properties"
        src="images/house-background2.jpg"
        alt=""
        width="1344"
        height="768"
        decoding="async"
      />
    </div>
    <div class="hero-shade"></div>
    <svg class="hero-divider" viewBox="0 0 1200 800" preserveAspectRatio="none" focusable="false">
      <path d="M768 0 C720 144 672 304 612 416 S600 592 672 800" />
    </svg>
  </div>
  <header class="hero-heading">
    <h1 id="hero-title">
      {{ 'HOME_HERO_TITLE' | translate }} <span>{{ 'HOME_HERO_TITLE_ACCENT' | translate }}</span>
    </h1>
    <p>{{ 'HOME_HERO_SUBTITLE' | translate }}</p>
  </header>
  <div class="hero-category hero-category-cars">
    <a class="hero-link hero-link-cars" routerLink="/cars"
      ><span>{{ 'HOME_HERO_BROWSE_CARS' | translate }}</span
      ><i class="bi" [ngClass]="isArabic ? 'bi-arrow-left' : 'bi-arrow-right'"></i
    ></a>
  </div>
  <div class="hero-category hero-category-properties">
    <a class="hero-link hero-link-properties" routerLink="/properties"
      ><span>{{ 'HOME_HERO_BROWSE_PROPERTIES' | translate }}</span
      ><i class="bi" [ngClass]="isArabic ? 'bi-arrow-left' : 'bi-arrow-right'"></i
    ></a>
  </div>
</section>
<div class="my-4">
  <h4 class="text-center bg-primary text-dark py-2 border rounded-top-4">
    {{ 'HOME_TOP_CARS' | translate }}
  </h4>
  @if (loadingCarResult$ | async) {
    <div class="text-center my-3">
      <app-loading></app-loading>
    </div>
  } @else {
    @if (carResults$ | async; as carResult) {
      <car-list [cars]="carResult.items"></car-list>
    }
  }
</div>
<div class="mt-4">
  <h4 class="text-center bg-primary text-dark py-2 border rounded-top-4">
    {{ 'HOME_TOP_PROPERTIES' | translate }}
  </h4>
  @if (loadingPropertyResult$ | async) {
    <div class="text-center my-3">
      <app-loading></app-loading>
    </div>
  } @else {
    @if (realEstateResults$ | async; as realEstateResults) {
      <app-property-list [properties]="realEstateResults.items"></app-property-list>
    }
  }
</div>
